import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air-receiver-tank',
  templateUrl: './air-receiver-tank.component.html',
  styleUrls: ['./air-receiver-tank.component.scss']
})
export class AirReceiverTankComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
